//@flow
import React, {useCallback} from 'react';

import {FilterItem, OrgUnitSelect} from '../../../components';
import Field from '../../../components/card/Field';
import {CommonFilter, type FilterProps} from '../../../components/hoc/common/handbook/CommonFilter';

import Datepicker from 'antd/lib/date-picker';
import moment from 'moment';
import {formatDateTimeToISOString} from '../../../lib/helpers';
import {ApproveYesNoSelect} from '../../../components/selects/AutoGeneratedEnumSelects';
import type {ApproveType} from '../../../lib/types';

export type LicensePlateChangeCostParamsFilter = {
  nodeId?: number,
  startDate?: string,
  endDate?: string,
  status?: ApproveType
};

export const LicensePlateChangeCostFilter = (
  props: FilterProps<LicensePlateChangeCostParamsFilter>
) => {
  const Filter = useCallback(
    (filterProps: $Shape<FilterProps<LicensePlateChangeCostParamsFilter>>) =>
      CommonFilter<LicensePlateChangeCostParamsFilter>({
        ...filterProps,
        ...props
      }),
    [props]
  );
  return (
    <Filter additionalFilter>
      {(values, changeValue) => (
        <>
          <FilterItem>
            <Field mBottomNone>
              <OrgUnitSelect
                size="small"
                value={values.nodeId}
                onlyBranches
                onChange={value => changeValue('nodeId', value)}
                isFilter={true}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <Datepicker
                size="small"
                placeholder="Дата начала"
                value={values.startDate ? moment(values.startDate) : undefined}
                format={'DD.MM.YYYY'}
                onChange={(value, dateString) => {
                  changeValue(
                    'startDate',
                    formatDateTimeToISOString(value, dateString)
                  );
                }}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <Datepicker
                size="small"
                placeholder="Дата окончания"
                value={values.endDate ? moment(values.endDate) : undefined}
                format={'DD.MM.YYYY'}
                onChange={(value, dateString) => {
                  changeValue(
                    'endDate',
                    formatDateTimeToISOString(value, dateString)
                  );
                }}
              />
            </Field>
          </FilterItem>
          <FilterItem>
            <Field mBottomNone>
              <ApproveYesNoSelect
                size="small"
                value={values.status}
                onChange={value => changeValue('status', value)}
              />
            </Field>
          </FilterItem>
        </>
      )}
    </Filter>
  );
};
export default LicensePlateChangeCostFilter;
